import type { RepPeriod } from "../../domain/repStats/repStats";

/** /rapports/sessions for one rep (or the team) and a period: the rep page and the dashboard link here. */
export const sessionsHref = (
  salesId: number | null,
  period?: RepPeriod,
  range?: { from: string; to: string },
): string => {
  const q = new URLSearchParams();
  if (salesId != null) q.set("rep", String(salesId));
  if (period) {
    q.set("period", period.preset);
    if (period.preset === "custom" && range) {
      q.set("from", range.from);
      q.set("to", range.to);
    }
  }
  const s = q.toString();
  return s ? `/rapports/sessions?${s}` : "/rapports/sessions";
};

/** /rapports/sessions/:id */
export const sessionHref = (sessionId: number): string =>
  `/rapports/sessions/${sessionId}`;

/** ?rep=<sales id> → that rep, else the whole team. */
export const parseRep = (search: URLSearchParams): number | null => {
  const raw = search.get("rep");
  const n = raw != null && /^\d{1,18}$/.test(raw) ? Number(raw) : NaN;
  return Number.isSafeInteger(n) ? n : null;
};
